"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
require("./dynamicform.css");
var _mdbreact = require("mdbreact");
require("bootstrap-css-only/css/bootstrap.min.css");
require("./mdb/css/mdb.css");
var _f1FileUploadReact = _interopRequireDefault(require("f1-file-upload-react"));
var _reactAutocomplete = _interopRequireDefault(require("react-autocomplete"));
var _f1WysiwygReact = _interopRequireDefault(require("f1-wysiwyg-react"));
var _draftJs = require("draft-js");
var _draftjsToHtml = _interopRequireDefault(require("draftjs-to-html"));
var _markdownDraftJs = require("markdown-draft-js");
var _validator = require("./validator");
var _reactI18next = require("react-i18next");
var _advanceDesign = require("./advanceDesign.js");
var _advanceDesignBootstrap = require("./advanceDesignBootstrap.js");
var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));
var _pickers = require("@material-ui/pickers");
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
var _reactSwitch = _interopRequireDefault(require("react-switch"));
var _f1GoogleMapCheckinReact = _interopRequireDefault(require("f1-google-map-checkin-react"));
var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() { }; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var labelComp = function labelComp(_ref) {
    var label = _ref.label;
    return /*#__PURE__*/_react.default.createElement("label", null, label, /*#__PURE__*/_react.default.createElement("i", null, "*"));
};
var DynamicForm = /*#__PURE__*/function (_React$Component) {
    _inherits(DynamicForm, _React$Component);
    var _super = _createSuper(DynamicForm);
    function DynamicForm(_props) {
        var _this;
        _classCallCheck(this, DynamicForm);
        _this = _super.call(this, _props);
        _defineProperty(_assertThisInitialized(_this), "state", {
            advanceLayoutFields: [],
            errors: {},
            isValidForm: false,
            collapseStates: {},
            isActiveCheckin: false,
            IsrenderComponent: false
        });
        _defineProperty(_assertThisInitialized(_this), "onCloseCheckInHandler", function () {
            setTimeout(function () {
                _this.setState({
                    IsrenderComponent: false
                });
            }, 1000);
            _this.setState({
                isActiveCheckin: false
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onTriggerCheckinMap", function () {
            setTimeout(function () {
                _this.setState({
                    IsrenderComponent: true
                });
            }, 1000);
            _this.setState({
                isActiveCheckin: true
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onCheckinHandler", function (m, position, address) {
            if (_this.props.onCheckinHandler) {
                _this.props.onCheckinHandler(position, address);
            }
            _this.onChange(address, m.key, "checkinField", m);
        });
        _defineProperty(_assertThisInitialized(_this), "reset", function (newState) {
            _this.setState(newState);
            //reset editor state
            if (_this.props.editorFields) {
                for (var j = 0; j < _this.props.editorFields.length; j++) {
                    if (_this.props.defaultValues && _this.props.defaultValues.hasOwnProperty(_this.props.editorFields[j])) {
                        var content = _this.getEditorContent("html", _this.props.defaultValues[_this.props.editorFields[j]]);
                        _this.setState(_defineProperty({}, "editorState" + _this.props.editorFields[j], content));
                    } else {
                        _this.setState(_defineProperty({}, "editorState" + _this.props.editorFields[j], _draftJs.EditorState.createEmpty()));
                    }
                }
            }
        });
        _defineProperty(_assertThisInitialized(_this), "onFileRef", function (ref, key) {
            _this["fileRef" + key] = ref;
        });
        _defineProperty(_assertThisInitialized(_this), "removeFile", function (e, file, index, key) {
            _this["fileRef" + key].removeFile(e, file, index);
        });
        _defineProperty(_assertThisInitialized(_this), "toggleCollapse", function (collapseID) {
            var collapseStates = _this.state.collapseStates;
            if (collapseStates.hasOwnProperty(collapseID)) {
                collapseStates[collapseID] = !collapseStates[collapseID];
            } else {
                collapseStates[collapseID] = true;
            }
            _this.setState({
                collapseStates: collapseStates
            });
        });
        _defineProperty(_assertThisInitialized(_this), "validateAllFields", function (key, value) {
            var isValidForm = true;
            if (_this.props.design === "advanceMaterial" || _this.props.design === "advanceBootstrap") {
                // iterate fieldsset

                for (var i = 0; i < _this.state.advanceLayoutFields.length; i++) {
                    // validate each field
                    var field = _this.state.advanceLayoutFields[i];
                    var validators = (0, _validator.getValidators)(field, field["key"]);
                    var errorMsg = "";
                    if (field["key"] == key) {
                        errorMsg = _this.applyCustomValidatorsToValidateForm(key, value);
                        if (!errorMsg) {
                            errorMsg = (0, _validator.applyValidators)(value, validators, key, _this.state);
                        }
                    } else {
                        errorMsg = _this.applyCustomValidatorsToValidateForm(field["key"], _this.state[field["key"]]);
                        if (!errorMsg) {
                            errorMsg = (0, _validator.applyValidators)(_this.state[field["key"]], validators, field["key"], _this.state);
                        }
                    }
                    if (errorMsg) {
                        isValidForm = false;
                        break;
                    }
                }
            } else {
                for (var _i = 0; _i < _this.props.model.length; _i++) {
                    // validate each field
                    var _field = _this.props.model[_i];
                    var _validators = (0, _validator.getValidators)(_field, _field["key"]);
                    var _errorMsg = "";
                    if (_field["key"] == key) {
                        _errorMsg = _this.applyCustomValidatorsToValidateForm(key, value);
                        if (!_errorMsg) {
                            _errorMsg = (0, _validator.applyValidators)(value, _validators, key, _this.state);
                        }
                    } else {
                        _errorMsg = _this.applyCustomValidatorsToValidateForm(_field["key"], _this.state[_field["key"]]);
                        if (!_errorMsg) {
                            _errorMsg = (0, _validator.applyValidators)(_this.state[_field["key"]], _validators, _field["key"], _this.state);
                        }
                    }
                    if (_errorMsg) {
                        isValidForm = false;
                        break;
                    }
                }
            }
            _this.setState({
                isValidForm: isValidForm
            });
        });
        _defineProperty(_assertThisInitialized(_this), "validateForm", function () {
            if (_this.props.design === "advanceMaterial" || _this.props.design === "advanceBootstrap") {
                for (var i = 0; i < _this.state.advanceLayoutFields.length; i++) {
                    // validate each field
                    var field = _this.state.advanceLayoutFields[i];
                    _this.applyCustomValidators(field["key"], _this.state[field["key"]]);
                    _this.validateField(field["key"], _this.state[field["key"]], field);
                    _this.validateAllFields(field["key"], _this.state[field["key"]], field);
                }
            } else {
                for (var _i2 = 0; _i2 < _this.props.model.length; _i2++) {
                    // validate each field
                    var _field2 = _this.props.model[_i2];
                    _this.applyCustomValidators(_field2["key"], _this.state[_field2["key"]]);
                    _this.validateField(_field2["key"], _this.state[_field2["key"]], _field2);
                    _this.validateAllFields(_field2["key"], _this.state[_field2["key"]], _field2);
                }
            }
        });
        _defineProperty(_assertThisInitialized(_this), "validateField", function (key, value, fieldObject) {
            var errors = _this.state.errors;
            delete errors[key];
            var validators = (0, _validator.getValidators)(fieldObject, key);
            var errorMsg = (0, _validator.applyValidators)(value, validators, key, _this.state);
            if (errorMsg) {
                errors[key] = errorMsg;
                _this.setState({
                    errors: errors
                });
            } else {
                _this.applyCustomValidators(key, value);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "applyCustomValidatorsToValidateForm", function (key, value) {
            if (!_this.props.customValidators) {
                return "";
            }
            var error = "";
            for (var i = 0; i < _this.props.customValidators.length; i++) {
                if (_this.props.customValidators[i]["key"] === key) {
                    var result = _this.props.customValidators[i]["validator"](key, value);
                    if (!result) {
                        error = _this.props.customValidators[i]["message"];
                    }
                }
            }
            return error;
        });
        _defineProperty(_assertThisInitialized(_this), "applyCustomValidators", function (key, value) {
            if (!_this.props.customValidators) {
                return "";
            }
            var errors = _this.state.errors;
            for (var i = 0; i < _this.props.customValidators.length; i++) {
                if (_this.props.customValidators[i]["key"] === key) {
                    var result = _this.props.customValidators[i]["validator"](key, value);
                    if (!result) {
                        errors[key] = _this.props.customValidators[i]["message"];
                        _this.setState({
                            errors: errors
                        });
                        break;
                    }
                }
            }
        });
        _defineProperty(_assertThisInitialized(_this), "onSubmit", function (e) {
            e.preventDefault();
            _this.validateForm();
            // console.log("this.state", this.state)
            if (_this.props.onSubmit) {
                _this.props.onSubmit(_this.state);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "onChange", function (e, key) {
            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "single";
            var m = arguments.length > 3 ? arguments[3] : undefined;
            var newValue = arguments.length > 4 ? arguments[4] : undefined;
            if (_this.props.onChange) {
                if (type === "autocompleteMultiselect") {
                    _this.props.onChange(e, m.key, _this.state, newValue);
                } else {
                    _this.props.onChange(e, m.key, _this.state);
                }
            }
            if (type === "file") {
                _this.setState(_defineProperty({}, key, e));
            } else if (type == "checkinField") {
                _this.setState(_defineProperty({}, key, e));
            } else if (type === "advanceControl") {
                _this.setState(_defineProperty({}, key, e && e.toString()), function () { });
                _this.validateField(key, e && e.toString(), m);
                _this.validateAllFields(key, e && e.toString());
            } else if (type === "single") {
                _this.setState(_defineProperty({}, key, e.target.value), function () { });
                _this.validateField(key, e.target.value, m);
                _this.validateAllFields(key, e.target.value);
            } else if (type === "switch") {
                _this.setState(_defineProperty({}, key, e));
                _this.validateField(key, e, m);
                _this.validateAllFields(key, e);
            } else if (type === "autocompleteMultiselect") {
                _this.setState(_defineProperty({}, key, newValue), function () { });
                _this.validateField(key, newValue, m);
                _this.validateAllFields(key, newValue);
            } else {
                // Array of values (e.g. checkbox): TODO: Optimization needed.
                var found = _this.state[key] ? _this.state[key].find(function (d) {
                    return d === e.target.value;
                }) : false;
                if (found) {
                    var data = _this.state[key].filter(function (d) {
                        return d !== found;
                    });
                    _this.setState(_defineProperty({}, key, data));
                    _this.validateField(key, data, m);
                    _this.validateAllFields(key, e.target.value);
                } else {
                    var others = _this.state[key] ? _toConsumableArray(_this.state[key]) : [];
                    _this.setState(_defineProperty({}, key, [e.target.value].concat(_toConsumableArray(others))));
                    _this.validateField(key, [e.target.value], m);
                    _this.validateAllFields(key, e.target.value);
                }
            }
        });
        _defineProperty(_assertThisInitialized(_this), "checkIsRequired", function (validators) {
            var isRequired = false;
            for (var i = 0; i < validators.length; i++) {
                if (validators[i]["name"] === "required") {
                    isRequired = true;
                    break;
                }
            }
            return isRequired;
        });
        _defineProperty(_assertThisInitialized(_this), "handleAutocompleteSelect", function (value, item, key) {
            var _this$setState11;
            _this.setState((_this$setState11 = {}, _defineProperty(_this$setState11, key + "label", value), _defineProperty(_this$setState11, key, item.id), _this$setState11));
            if (_this.props.onAutocompleteSelect) {
                _this.props.onAutocompleteSelect(key, value, item);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "getOutputFromState", function (outputType, editorState) {
            var outputContent = "";
            if (outputType === "markdown") {
                outputContent = (0, _markdownDraftJs.draftToMarkdown)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
            } else {
                outputContent = (0, _draftjsToHtml.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
            }
            return outputContent;
        });
        _defineProperty(_assertThisInitialized(_this), "getEditorContent", function (inputType, content) {
            var editorContent = "";
            if (content) {
                if (inputType === "markdown") {
                    var rawData = (0, _markdownDraftJs.markdownToDraft)(content);
                    var contentState = (0, _draftJs.convertFromRaw)(rawData);
                    editorContent = _draftJs.EditorState.createWithContent(contentState);
                } else {
                    var contentBlocks = (0, _draftJs.convertFromHTML)(content);
                    var editorRawContent = _draftJs.ContentState.createFromBlockArray(contentBlocks);
                    editorContent = _draftJs.EditorState.createWithContent(editorRawContent);
                }
            }
            return editorContent;
        });
        _defineProperty(_assertThisInitialized(_this), "onEditorStateChange", function (editorState, m) {
            _this.setState(_defineProperty({}, "editorState" + m.key, editorState));
            var output = _this.getOutputFromState("html", editorState);
            _this.setState(_defineProperty({}, m.key, output));
            if (_this.props.onChange) {
                _this.props.onChange(output, m.key);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "hasRequiredValidation", function (field) {
            if (!field.hasOwnProperty('validators')) {
                return false;
            }
            var required = false;
            var _iterator = _createForOfIteratorHelper(field.validators),
                _step;
            try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var validation = _step.value;
                    if (validation.name === 'required' && validation.value == true) {
                        required = true;
                        break;
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally {
                _iterator.f();
            }
            return required;
        });
        _defineProperty(_assertThisInitialized(_this), "renderForm", function () {
            var model = _this.props.model;
            var defaultValues = _this.props.defaultValues;
            _this.iconInputParent = _this.props.showIcons ? 'icon-input-wrap' : '';
            _this.textIconClass = _this.props.showIcons ? ' icon-input' : '';
            var formUI = model.map(function (m, index) {
                var key = m.key;
                var type = m.type || "text";
                var props = m.props || {};
                var name = m.key;
                var value = m.value;
                var pattern = m.pattern;
                var placeholder = m.placeholder;
                var required = m.required;
                var t = _this.props.t;
                var target = key;
                value = _this.state[target] || "";
                var requiredFieldClass = _this.hasRequiredValidation(m) && _this.props.showAstersikOnRequiredFields ? 'requiredField' : '';
                var className = _this.state.errors[m.key] ? "form-control is-invalid" : "form-control";
                var classNameCheckbox = _this.state.errors[m.key] ? "custom-control-input is-invalid" : "custom-control-input";
                var classNameRadio = _this.state.errors[m.key] ? "custom-control-input is-invalid" : "custom-control-input";
                var errors = _this.state.errors;
                Object.assign(errors, _this.props.extErrors);
                var validationMessage = errors[m.key] ? _this.state.errors[m.key] : "";
                var input = (m.hide ? false : true) ? /*#__PURE__*/_react.default.createElement("input", _extends({}, props, {
                    className: className + _this.textIconClass,
                    type: type,
                    key: key,
                    name: name,
                    autoComplete: m.autoComplete,
                    maxlength: m.maxlength,
                    value: _this.state[key],
                    onChange: function onChange(e) {
                        _this.onChange(e, target, "single", m);
                    },
                    id: m.id,
                    disabled: m.disabled,
                    placeholder: m.placeholder
                })) : "";
                if (type == "radio" && (m.hide ? false : true)) {
                    var _t = _this.props.t;
                    input = m.options.map(function (o) {
                        var _extends2;
                        var checked = o.value === _this.state[key];
                        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
                            key: "fr" + o.key
                        }, /*#__PURE__*/_react.default.createElement("div", {
                            className: "custom-control custom-radio " + o.className + (checked ? ' activeRadio' : '')
                        }, /*#__PURE__*/_react.default.createElement("input", _extends({}, props, (_extends2 = {
                            className: classNameRadio,
                            type: type,
                            key: o.key,
                            id: o.key,
                            name: o.name,
                            checked: checked,
                            value: o.value,
                            onChange: function onChange(e) {
                                _this.onChange(e, o.name, "single", m);
                            }
                        }, _defineProperty(_extends2, "id", o.id), _defineProperty(_extends2, "disabled", o.disabled), _extends2))), /*#__PURE__*/_react.default.createElement("label", {
                            htmlFor: o.key,
                            className: "grey-text custom-control-label",
                            key: "ll" + o.key
                        }, _t(o.label)), _this.props.renderRadioIcons ? _this.props.renderRadioIcons(o) : ''));
                    });
                    input = /*#__PURE__*/_react.default.createElement("div", {
                        className: ""
                    }, input);
                }
                if (type == "select" && (m.hide ? false : true)) {
                    var _t2 = _this.props.t;
                    input = m.options.map(function (o) {
                        var checked = o.value === _this.state["key"];
                        return /*#__PURE__*/_react.default.createElement("option", _extends({}, props, o, {
                            className: className,
                            key: o.key,
                            value: o.value
                        }), _t2(o.label));
                    });
                    input = /*#__PURE__*/_react.default.createElement("select", {
                        className: className,
                        value: _this.state[key],
                        onChange: function onChange(e) {
                            _this.onChange(e, m.key, "single", m);
                        },
                        id: m.id,
                        disabled: m.disabled
                    }, input);
                }
                if (type == "tel" && (m.hide ? false : true)) {
                    var _t3 = _this.props.t;
                    input = /*#__PURE__*/_react.default.createElement("input", {
                        className: className,
                        type: "tel",
                        key: key,
                        name: name,
                        value: _this.state[key],
                        placeholder: placeholder,
                        pattern: pattern,
                        required: required,
                        disabled: m.disabled,
                        id: m.id,
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "single", m);
                        }
                    });
                }
                if (type == "checkinField" && (m.hide ? false : true)) {
                    var _t4 = _this.props.t;
                    // console.log("this is checkinnnnnnnn")
                    input = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
                        className: className,
                        type: "text",
                        key: key,
                        name: name,
                        value: _this.state[key],
                        placeholder: placeholder,
                        pattern: pattern,
                        required: required,
                        renderComponent: true,
                        disabled: m.disabled,
                        id: m.id,
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "single", m);
                        }
                    }), /*#__PURE__*/_react.default.createElement("i", {
                        className: m.locationIcon + " locationTrigger",
                        onClick: _this.onTriggerCheckinMap
                    }), /*#__PURE__*/_react.default.createElement(_f1GoogleMapCheckinReact.default, {
                        IsrenderComponent: _this.state.IsrenderComponent,
                        config: _this.props.checkInConfig,
                        onCheckinHandler: function onCheckinHandler(position, address) {
                            _this.onCheckinHandler(m, position, address);
                        },
                        isActive: _this.state.isActiveCheckin,
                        onCloseHandler: _this.onCloseCheckInHandler,
                        height: m.height,
                        locationLabel: m.locationLabel,
                        okayButtonText: m.okayButtonText,
                        cancelButtonText: m.cancelButtonText
                    }));
                }
                if (type == "range" && (m.hide ? false : true)) {
                    var _t5 = _this.props.t;
                    input = /*#__PURE__*/_react.default.createElement("input", {
                        className: className,
                        type: "range",
                        key: key,
                        name: name,
                        value: _this.state[key],
                        min: m.min,
                        max: m.max,
                        step: m.step,
                        required: required,
                        disabled: m.disabled,
                        placeholder: m.placeholder,
                        id: m.id,
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "single", m);
                        }
                    });
                }
                if (type === "CustomSwitch" && (m.hide ? !m.hide : true)) {
                    input = /*#__PURE__*/_react.default.createElement(_reactSwitch.default, {
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "switch", m);
                        },
                        checked: _this.state[key],
                        value: _this.state[key],
                        handleDiameter: m.handleDiameter,
                        offColor: m.offColor,
                        onColor: m.onColor,
                        offHandleColor: m.offHandleColor,
                        onHandleColor: m.onHandleColor,
                        height: m.height,
                        width: m.width,
                        borderRadius: m.borderRadius,
                        activeBoxShadow: m.activeBoxShadow,
                        uncheckedIcon: m.uncheckedIcon,
                        uncheckedHandleIcon: m.uncheckedHandleIcon,
                        boxShadow: m.boxShadow,
                        id: m.id,
                        className: m.className,
                        disabled: m.disabled,
                        checkedIcon: m.checkedIcon
                    });
                }
                if (type === "materialSwitch" && (m.hide ? !m.hide : true)) {
                    var _React$createElement;
                    input = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Switch.default
                        //checked={this.state[key] }
                        , (_React$createElement = {
                            value: _this.state[key],
                            size: m.size,
                            disabled: m.disabled,
                            classes: m.classes,
                            onChange: function onChange(e) {
                                _this.onChange(e, target, "single", m);
                            },
                            name: m.name,
                            color: m.color,
                            inputProps: {
                                'aria-label': 'Switch A'
                            },
                            checkedIcon: m.checkedIcon,
                            disableRipple: m.disableRipple,
                            edge: m.edge,
                            icon: m.icon,
                            id: m.id
                        }, _defineProperty(_React$createElement, "inputProps", m.inputProps), _defineProperty(_React$createElement, "inputRef", m.inputRef), _defineProperty(_React$createElement, "required", m.required), _React$createElement)));
                }
                if (type === "materialDate" && (m.hide ? !m.hide : true)) {
                    input = /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
                        utils: _dateFns.default
                    }, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardDatePicker, _extends({}, props, {
                        readOnly: m.readOnly,
                        inputVariant: m.inputVariant,
                        minDate: m.minDate,
                        maxDate: m.maxDate,
                        label: m.fieldLabel,
                        autoOk: m.autoOk,
                        okLabel: m.okLabel,
                        minDateMessage: m.minDateMessage,
                        maxDateMessage: m.maxDateMessage,
                        disableToolbar: m.disableToolbar,
                        variant: m.variant,
                        format: m.format,
                        margin: m.margin,
                        key: key,
                        name: name,
                        id: m.id,
                        disabled: m.disabled,
                        placeholder: m.placeholder,
                        value: _this.state[key] ? _this.state[key] : null,
                        className: className,
                        onChange: function onChange(e) {
                            // console.log(e);

                            _this.onChange(e, target, "advanceControl", m);
                        },
                        KeyboardButtonProps: {
                            "aria-label": "change date"
                        },
                        showTodayButton: m.showTodayButton,
                        clearable: m.clearable
                    })));
                }
                if (type === "date" && (m.hide ? false : true)) {
                    var _t6 = _this.props.t;
                    var d = new Date();
                    var month = d.getMonth() <= 8 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
                    var day = d.getDate() <= 9 ? "0" + d.getDate() : d.getDate();
                    var time = d.getFullYear() + "-" + month + "-" + day;
                    input = /*#__PURE__*/_react.default.createElement("input", {
                        className: className,
                        type: "date",
                        key: key,
                        name: name,
                        value: _this.state[key] ? _this.state[key] : m.noDate === null ? null : time,
                        id: m.id,
                        disabled: m.disabled,
                        min: m.min,
                        max: m.max,
                        placeholder: m.placeholder,
                        format: m.format,
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "single", m);
                        }
                    });
                }
                if (type === "datetime-local" && (m.hide ? false : true)) {
                    var _t7 = _this.props.t;
                    var _d = new Date();
                    var _month = _d.getMonth() <= 8 ? "0" + (_d.getMonth() + 1) : _d.getMonth() + 1;
                    var _day = _d.getDate() <= 9 ? "0" + _d.getDate() : _d.getDate();
                    var _time = _d.getFullYear() + "-" + _month + "-" + _day + "T" + _d.getHours() + ":" + _d.getMinutes();
                    input = /*#__PURE__*/_react.default.createElement("input", {
                        className: className,
                        type: "datetime-local",
                        key: key,
                        name: name,
                        value: _this.state[key] ? _this.state[key] : _time,
                        id: m.id,
                        disabled: m.disabled,
                        min: m.min,
                        max: m.max,
                        placeholder: m.placeholder,
                        format: m.format,
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "single", m);
                        }
                    });
                }
                if (type === "textarea" && (m.hide ? false : true)) {
                    input = /*#__PURE__*/_react.default.createElement("textarea", {
                        className: className,
                        key: key,
                        name: name,
                        value: _this.state[key],
                        placeholder: placeholder,
                        rows: m.rows,
                        id: m.id,
                        disabled: m.disabled,
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "single", m);
                        }
                    });
                }
                if (type === "link" && (m.hide ? false : true)) {
                    var _t8 = _this.props.t;
                    input = /*#__PURE__*/_react.default.createElement("a", {
                        href: m.href,
                        key: key,
                        id: m.id
                    }, m.value);
                }
                if (type == "button" && (m.hide ? false : true)) {
                    var _t9 = _this.props.t;
                    input = m.customButton ? /*#__PURE__*/_react.default.createElement("span", {
                        key: key,
                        id: m.id
                    }, m.customButton) : /*#__PURE__*/_react.default.createElement("button", _extends({
                        type: m.type,
                        className: m.className,
                        key: key,
                        id: m.id
                    }, m, {
                        onClick: function onClick() {
                            return _this.props.buttonNormalClick(m.id, m.key, _this.state);
                        }
                    }), m.value);
                }
                if (type === "autocomplete" && (m.hide ? false : true)) {
                    input = /*#__PURE__*/_react.default.createElement(_reactAutocomplete.default, {
                        items: _this.props.autoCompleteItems[key],
                        shouldItemRender: function shouldItemRender(item, value) {
                            return item.label.toLowerCase().indexOf(value.toLowerCase()) > -1;
                        },
                        getItemValue: function getItemValue(item) {
                            return item.label;
                        },
                        renderItem: function renderItem(item, highlighted) {
                            return /*#__PURE__*/_react.default.createElement("div", {
                                className: "items-wrapper",
                                key: item.id,
                                style: {
                                    backgroundColor: highlighted ? "#eee" : "transparent"
                                }
                            }, item.label);
                        },
                        renderMenu: function renderMenu(items, value, style) {
                            if (items.length > 0) {
                                return /*#__PURE__*/_react.default.createElement("div", {
                                    className: "autocomple-menu-wrapper",
                                    style: _objectSpread(_objectSpread({}, style), _this.menuStyle),
                                    children: items
                                });
                            } else {
                                return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
                            }
                        },
                        value: _this.state[key + "label"],
                        name: key + "label",
                        wrapperStyle: {},
                        wrapperProps: {
                            className: "md-form md-outline autocomplete-wrapper"
                        },
                        inputProps: {
                            className: "form-control form-control",
                            type: "text",
                            label: m.label,
                            placeholder: m.placeholder,
                            disabled: m.disabled
                        },
                        onChange: function onChange(e) {
                            _this.onChange(e, key + "label", "single", m);
                            _this.onChange(e, key, "single", m);
                        },
                        onSelect: function onSelect(value, item) {
                            _this.handleAutocompleteSelect(value, item, key);
                            var event = new Event('autocompleteEvent');
                            Object.defineProperty(event, 'target', {
                                writable: false,
                                value: {
                                    'value': item.id
                                }
                            });
                            _this.onChange(event, key, "single", m);
                        }
                    });
                }
                if (type === "autocompleteMultiselect" && (m.hide ? !m.hide : true)) {
                    input = /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
                        multiple: true,
                        options: m.options,
                        getOptionLabel: function getOptionLabel(option) {
                            return option.key;
                        }
                        // defaultValue={[{ title: 'The Shawshank Redemption', year: 1994 }]}
                        ,
                        className: className,
                        value: _this.state[key],
                        onChange: function onChange(e, newValue) {
                            _this.onChange(e, m.key, "autocompleteMultiselect", m, newValue);
                        },
                        id: m.id,
                        disabled: m.disabled,
                        renderInput: function renderInput(params) {
                            return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, params, {
                                placeholder: m.placeholder
                            }));
                        }
                    });
                }
                if (type === "file" && (m.hide ? false : true)) {
                    var str = new String(m.regex);
                    var str1 = eval(str.toString());
                    input = /*#__PURE__*/_react.default.createElement(_f1FileUploadReact.default, _extends({
                        onDropHandler: function onDropHandler(files, event) {
                            _this.onChange(files, m.key, "file", m);
                        },
                        componentType: m.componentType,
                        acceptFileTypes: m.acceptFileTypes,
                        dropTitle: m.dropTitle,
                        dropSubTitle: m.dropSubTitle,
                        maxFileSize: m.maxFileSize,
                        onFileRemove: _this.props.onFileRemove,
                        renderUploadedFilesItem: function renderUploadedFilesItem(file, index) {
                            return _this.props.renderUploadedFilesItem(file, index, m.key);
                        },
                        onRef: function onRef(ref) {
                            return _this["fileRef" + m.key] = ref;
                        },
                        defaultUploadedFiles: _this.state[key]
                    }, m, {
                        regex: str1
                    }));
                }
                if (type === "texteditor" && (m.hide ? false : true)) {
                    var _t10 = _this.props.t;
                    input = /*#__PURE__*/_react.default.createElement("div", {
                        className: ""
                    }, /*#__PURE__*/_react.default.createElement("label", {
                        htmlFor: m.key,
                        className: ""
                    }, _t10(m.label)), /*#__PURE__*/_react.default.createElement(_f1WysiwygReact.default, _extends({
                        editorState: _this.state["editorState" + m.key]
                    }, m, {
                        onEditorStateChange: function onEditorStateChange(editorState) {
                            return _this.onEditorStateChange(editorState, m);
                        },
                        defaultContent: _this.state[key]
                    })));
                }
                if (type === "label" && (m.hide ? false : true)) {
                    var _t11 = _this.props.t;
                    input = /*#__PURE__*/_react.default.createElement("label", {
                        className: m.key + " " + m.className
                    }, _t11(m.value));
                }
                if (type == "checkbox" && (m.hide ? false : true)) {
                    var _t12 = _this.props.t;
                    input = m.options.map(function (o) {
                        //let checked = o.value == value;
                        var checked = false;
                        if (value && value.length > 0) {
                            checked = value.indexOf(o.value) > -1 ? true : false;
                        }
                        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
                            key: "cfr" + o.key
                        }, /*#__PURE__*/_react.default.createElement("div", {
                            className: "custom-control custom-checkbox"
                        }, o.tooltipTitle ? /*#__PURE__*/_react.default.createElement("i", {
                            className: "fa fa-info-circle field-child-tooltip",
                            title: o.tooltipTitle
                        }) : "", /*#__PURE__*/_react.default.createElement("input", _extends({}, props, {
                            className: classNameCheckbox,
                            type: type,
                            key: o.key,
                            id: o.key,
                            name: o.name,
                            checked: checked,
                            value: o.value,
                            onChange: function onChange(e) {
                                _this.onChange(e, m.key, "multiple", m);
                            },
                            disabled: o.disabled
                        })), /*#__PURE__*/_react.default.createElement("label", {
                            htmlFor: o.key,
                            className: "custom-control-label grey-text",
                            key: "ll" + o.key
                        }, _t12(o.label))));
                    });
                    input = /*#__PURE__*/_react.default.createElement("div", {
                        className: ""
                    }, input);
                }
                if (type == "icon" && (m.hide ? false : true)) {
                    input = /*#__PURE__*/_react.default.createElement("span", {
                        key: key,
                        id: m.key
                    }, /*#__PURE__*/_react.default.createElement("img", {
                        src: m.path,
                        name: m.name,
                        className: "imgIcon"
                    }));
                }
                return /*#__PURE__*/_react.default.createElement("div", {
                    key: "g" + key,
                    className: "form-group control" + (index + 1) + " " + _this.iconInputParent + " " + requiredFieldClass
                }, (m.hide ? false : true) ? /*#__PURE__*/_react.default.createElement("label", {
                    className: "grey-text",
                    key: "l" + key,
                    htmlFor: key
                }, t(m.label)) : "", m.tooltip ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBTooltip, {
                    placement: m.tooltipPlacement ? m.tooltipPlacement : 'top',
                    className: "tooltipWrap"
                }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBBtn, {
                    color: "none",
                    tag: "span",
                    className: "tootipTrigger"
                }, /*#__PURE__*/_react.default.createElement("i", {
                    className: m.tooltipIconClass ? m.tooltipIconClass : 'fa fa-info-circle'
                })), /*#__PURE__*/_react.default.createElement("div", {
                    className: "tooltipText"
                }, m.tooltipText ? m.tooltipText : '')) : '', _this.props.showIcons ? /*#__PURE__*/_react.default.createElement("div", {
                    className: "inputBox"
                }, input, _this.props.showIcons && m.iconClassName && !m.hide ? /*#__PURE__*/_react.default.createElement("i", {
                    className: m.iconClassName + " text-icon"
                }) : '', m.showPassword && m.type == "Password" ? /*#__PURE__*/_react.default.createElement("i", {
                    className: m.type == "Password" ? "fa fa-eye text-icon-right" : "fa fa-eye-slash text-icon-right",
                    onClick: function onClick(e) {
                        if (m.type == "Password") {
                            m.type = "text";
                            document.getElementsByName("Password")[0].setAttribute("type", "text");
                            e.target.className = "fa fa-eye-slash text-icon-right";
                            return m;
                        } else {
                            m.type = "Password";
                            document.getElementsByName("Password")[0].setAttribute("type", "password");
                            e.target.className = "fa fa-eye text-icon-right";
                            return m;
                        }
                    }
                }) : '') : "", !_this.props.showIcons ? input : "", (m.hide ? false : true) ? validationMessage ? /*#__PURE__*/_react.default.createElement("span", {
                    className: "text-danger"
                }, " ", t(validationMessage)) : "" : "");
            });
            return formUI;
        });
        _defineProperty(_assertThisInitialized(_this), "renderMaterialForm", function () {
            var model = _this.props.model;
            var defaultValues = _this.props.defaultValues;
            var formUI = model.map(function (m, index) {
                var key = m.key;
                var label = m.label;
                var type = m.type || "text";
                var props = m.props || {};
                var name = m.key;
                var value = m.value;
                var pattern = m.pattern;
                var placeholder = m.placeholder;
                var required = m.required;
                var t = _this.props.t;
                var target = key;
                value = _this.state[target] || "";
                var requiredFieldClass = _this.hasRequiredValidation(m) && _this.props.showAstersikOnRequiredFields ? 'requiredField' : '';
                var className = _this.state.errors[m.key] ? "form-control is-invalid" : "form-control";
                var classNameCheckbox = _this.state.errors[m.key] ? "custom-control-input is-invalid" : "custom-control-input";
                var classNameRadio = _this.state.errors[m.key] ? "custom-control-input is-invalid" : "custom-control-input";
                var errors = _this.state.errors;
                Object.assign(errors, _this.props.extErrors);
                var validationMessage = errors[m.key] ? _this.state.errors[m.key] : "";
                var input = (m.hide ? false : true) ? /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, _extends({}, props, {
                    className: className,
                    icon: m.hasOwnProperty("icon") && m.icon ? m.icon : "",
                    label: t(m.label),
                    type: type,
                    key: key,
                    name: name,
                    maxlength: m.maxlength,
                    value: _this.state[key],
                    onChange: function onChange(e) {
                        _this.onChange(e, target, "single", m);
                    },
                    outline: _this.props.materialOutline,
                    id: m.id,
                    disabled: m.disabled
                })) : "";
                if (type == "radio" && (m.hide ? false : true)) {
                    var _t13 = _this.props.t;
                    input = m.options.map(function (o) {
                        var _extends3;
                        var checked = o.value === _this.state[key];
                        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
                            key: "fr" + o.key
                        }, /*#__PURE__*/_react.default.createElement("div", {
                            className: "custom-control custom-radio " + o.className + (checked ? ' activeRadio' : '')
                        }, /*#__PURE__*/_react.default.createElement("input", _extends({}, props, (_extends3 = {
                            className: classNameRadio,
                            type: type,
                            key: o.key,
                            id: o.key,
                            name: o.name,
                            checked: checked,
                            value: o.value,
                            onChange: function onChange(e) {
                                _this.onChange(e, o.name, "single", m);
                            }
                        }, _defineProperty(_extends3, "id", o.id), _defineProperty(_extends3, "disabled", o.disabled), _extends3))), /*#__PURE__*/_react.default.createElement("label", {
                            htmlFor: o.key,
                            className: "grey-text custom-control-label",
                            key: "ll" + o.key
                        }, _t13(o.label)), _this.props.renderRadioIcons ? _this.props.renderRadioIcons(o) : ''));
                    });
                    input = /*#__PURE__*/_react.default.createElement("div", {
                        className: ""
                    }, /*#__PURE__*/_react.default.createElement("label", {
                        className: "grey-text",
                        htmlFor: key
                    }, _t13(label)), input);
                }
                if (type == "select" && (m.hide ? false : true)) {
                    var _t14 = _this.props.t;
                    input = m.options.map(function (o) {
                        var checked = o.value === _this.state[key];
                        return /*#__PURE__*/_react.default.createElement("option", _extends({}, props, o, {
                            // disabled={o.disabled?o.disabled:false}
                            className: className,
                            key: o.key,
                            value: o.value
                        }), _t14(o.label));
                    });
                    input = /*#__PURE__*/_react.default.createElement("div", {
                        className: "form-group"
                    }, /*#__PURE__*/_react.default.createElement("label", {
                        className: "grey-text",
                        htmlFor: key
                    }, _t14(label)), /*#__PURE__*/_react.default.createElement("select", {
                        className: className,
                        value: _this.state[key],
                        onChange: function onChange(e) {
                            _this.onChange(e, m.key, "single", m);
                        },
                        id: m.id,
                        disabled: m.disabled
                    }, input));
                }
                if (type == "tel" && (m.hide ? false : true)) {
                    var _t15 = _this.props.t;
                    input = /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, {
                        className: className,
                        type: "tel",
                        key: key,
                        name: name,
                        value: _this.state[key],
                        placeholder: placeholder,
                        label: label,
                        pattern: pattern,
                        required: required,
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "single", m);
                        },
                        outline: _this.props.materialOutline,
                        id: m.id,
                        disabled: m.disabled
                    });
                }
                if (type == "range" && (m.hide ? false : true)) {
                    var _t16 = _this.props.t;
                    input = /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, {
                        className: className,
                        type: "range",
                        key: key,
                        name: name,
                        value: _this.state[key],
                        placeholder: placeholder,
                        label: label,
                        pattern: pattern,
                        required: required,
                        min: m.min,
                        max: m.max,
                        step: m.step,
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "single", m);
                        },
                        outline: _this.props.materialOutline,
                        id: m.id,
                        disabled: m.disabled
                    });
                }
                if (type === "materialDate" && (m.hide ? !m.hide : true)) {
                    input = /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
                        utils: _dateFns.default
                    }, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardDatePicker, _extends({}, props, {
                        readOnly: m.readOnly,
                        inputVariant: m.inputVariant,
                        minDate: m.minDate,
                        maxDate: m.maxDate,
                        label: m.fieldLabel,
                        minDateMessage: m.minDateMessage,
                        maxDateMessage: m.maxDateMessage,
                        autoOk: m.autoOk,
                        okLabel: m.okLabel,
                        disableToolbar: m.disableToolbar,
                        variant: m.variant,
                        format: m.format,
                        margin: m.margin,
                        key: key,
                        name: name,
                        id: m.id,
                        disabled: m.disabled,
                        placeholder: m.placeholder,
                        value: _this.state[key] ? _this.state : null,
                        className: className,
                        onChange: function onChange(e) {
                            // console.log(e);

                            _this.onChange(e, target, "advanceControl", m);
                        },
                        KeyboardButtonProps: {
                            "aria-label": "change date"
                        },
                        showTodayButton: m.showTodayButton,
                        clearable: m.clearable
                    })));
                }
                if (type === "date" && (m.hide ? false : true)) {
                    var _t17 = _this.props.t;
                    var d = new Date();
                    var month = d.getMonth() <= 8 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
                    var day = d.getDate() <= 9 ? "0" + d.getDate() : d.getDate();
                    var time = d.getFullYear() + "-" + month + "-" + day;
                    input = /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, {
                        className: className,
                        type: "date",
                        key: key,
                        name: name,
                        label: label,
                        value: _this.state[key] ? _this.state[key] : m.noDate === null ? null : time,
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "single", m);
                        },
                        outline: _this.props.materialOutline,
                        id: m.id,
                        disabled: m.disabled,
                        min: m.min,
                        max: m.max,
                        placeholder: m.placeholder,
                        format: m.format
                    });
                }
                if (type === "datetime-local" && (m.hide ? false : true)) {
                    var _t18 = _this.props.t;
                    var _d2 = new Date();
                    var _month2 = _d2.getMonth() <= 8 ? "0" + (_d2.getMonth() + 1) : _d2.getMonth() + 1;
                    var _day2 = _d2.getDate() <= 9 ? "0" + _d2.getDate() : _d2.getDate();
                    var _time2 = _d2.getFullYear() + "-" + _month2 + "-" + _day2 + "T" + _d2.getHours() + ":" + _d2.getMinutes();
                    input = /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, {
                        className: className,
                        type: "datetime-local",
                        min: m.min,
                        max: m.max,
                        key: key,
                        name: name,
                        label: label,
                        value: _this.state[key] ? _this.state[key] : _time2,
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "single", m);
                        },
                        outline: _this.props.materialOutline,
                        id: m.id,
                        disabled: m.disabled,
                        placeholder: m.placeholder,
                        format: m.format
                    });
                }
                if (type == "link" && (m.hide ? false : true)) {
                    var _t19 = _this.props.t;
                    input = /*#__PURE__*/_react.default.createElement("a", {
                        href: m.href,
                        key: key,
                        id: m.id
                    }, m.value);
                }
                if (type == "button" && (m.hide ? false : true)) {
                    var _t20 = _this.props.t;
                    input = m.customButton ? /*#__PURE__*/_react.default.createElement("span", {
                        key: key,
                        id: m.id
                    }, m.customButton) : /*#__PURE__*/_react.default.createElement("button", _extends({
                        type: m.type,
                        className: m.className,
                        key: key,
                        id: m.id
                    }, m, {
                        onClick: function onClick() {
                            return _this.props.buttonNormalClick(m.id, m.key, _this.state);
                        }
                    }), m.value);
                }
                if (type === "label" && (m.hide ? false : true)) {
                    var _t21 = _this.props.t;
                    input = /*#__PURE__*/_react.default.createElement("label", {
                        className: m.key + " " + m.className
                    }, _t21(m.value));
                }
                if (type === "autocomplete" && (m.hide ? false : true)) {
                    input = /*#__PURE__*/_react.default.createElement(_reactAutocomplete.default, {
                        items: _this.props.autoCompleteItems[key],
                        shouldItemRender: function shouldItemRender(item, value) {
                            return item.label.toLowerCase().indexOf(value.toLowerCase()) > -1;
                        },
                        getItemValue: function getItemValue(item) {
                            return item.label;
                        },
                        renderItem: function renderItem(item, highlighted) {
                            return /*#__PURE__*/_react.default.createElement("div", {
                                className: "items-wrapper",
                                key: item.id,
                                style: {
                                    backgroundColor: highlighted ? "#eee" : "transparent",
                                    position: "relative"
                                }
                            }, item.label);
                        },
                        renderMenu: function renderMenu(items, value, style) {
                            if (items.length > 0) {
                                return /*#__PURE__*/_react.default.createElement("div", {
                                    className: "autocomple-menu-wrapper",
                                    style: _objectSpread(_objectSpread({}, style), _this.menuStyle),
                                    children: items
                                });
                            } else {
                                return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
                            }
                        },
                        value: _this.state[key + "label"],
                        name: key + "label",
                        wrapperStyle: {},
                        wrapperProps: {
                            className: "md-form md-outline autocomplete-wrapper"
                        },
                        inputProps: {
                            className: "form-control form-control",
                            type: "text",
                            label: m.label,
                            placeholder: m.placeholder,
                            disabled: m.disabled
                        },
                        onChange: function onChange(e) {
                            _this.onChange(e, key + "label", "single", m);
                            _this.onChange(e, key, "single", m);
                        },
                        onSelect: function onSelect(value, item) {
                            _this.handleAutocompleteSelect(value, item, key);
                            var event = new Event('autocompleteEvent');
                            Object.defineProperty(event, 'target', {
                                writable: false,
                                value: {
                                    'value': item.id
                                }
                            });
                            _this.onChange(event, key, "single", m);
                        }
                    });
                }
                if (type === "file" && (m.hide ? false : true)) {
                    var str = new String(m.regex);
                    var str1 = eval(str.toString());
                    input = /*#__PURE__*/_react.default.createElement(_f1FileUploadReact.default, _extends({
                        onDropHandler: function onDropHandler(files, event) {
                            _this.onChange(files, target, "file", m);
                        },
                        componentType: m.componentType,
                        acceptFileTypes: m.acceptFileTypes,
                        dropTitle: m.dropTitle,
                        dropSubTitle: m.dropSubTitle,
                        maxFileSize: m.maxFileSize,
                        onFileRemove: _this.props.onFileRemove,
                        renderUploadedFilesItem: function renderUploadedFilesItem(file, index) {
                            return _this.props.renderUploadedFilesItem(file, index, m.key);
                        },
                        onRef: function onRef(ref) {
                            return _this["fileRef" + m.key] = ref;
                        },
                        defaultUploadedFiles: _this.state[key]
                    }, m, {
                        regex: str1
                    }));
                }

                //textarea
                if (type === "textarea" && (m.hide ? false : true)) {
                    var _t22 = _this.props.t;
                    input = /*#__PURE__*/_react.default.createElement(_mdbreact.MDBInput, _extends({}, props, {
                        className: className,
                        icon: m.hasOwnProperty("icon") && m.icon ? m.icon : "",
                        label: _t22(m.label),
                        type: "textarea",
                        rows: m.rows,
                        key: key,
                        name: name,
                        value: _this.state[key],
                        onChange: function onChange(e) {
                            _this.onChange(e, target, "single", m);
                        },
                        outline: _this.props.materialOutline,
                        id: m.id,
                        disabled: m.disabled
                    }));
                }
                if (type === "texteditor" && (m.hide ? false : true)) {
                    var _t23 = _this.props.t;
                    input = /*#__PURE__*/_react.default.createElement("div", {
                        className: ""
                    }, /*#__PURE__*/_react.default.createElement("label", {
                        htmlFor: m.key,
                        className: ""
                    }, _t23(m.label)), /*#__PURE__*/_react.default.createElement(_f1WysiwygReact.default, _extends({
                        editorState: _this.state["editorState" + m.key]
                    }, m, {
                        onEditorStateChange: function onEditorStateChange(editorState) {
                            return _this.onEditorStateChange(editorState, m);
                        },
                        defaultContent: _this.state[key]
                    })));
                }
                if (type == "checkbox" && (m.hide ? false : true)) {
                    var _t24 = _this.props.t;
                    input = m.options.map(function (o) {
                        //let checked = o.value == value;
                        var checked = false;
                        if (value && value.length > 0) {
                            checked = value.indexOf(o.value) > -1 ? true : false;
                        }
                        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
                            key: "cfr" + o.key
                        }, /*#__PURE__*/_react.default.createElement("div", {
                            className: "custom-control custom-checkbox"
                        }, o.tooltipTitle ? /*#__PURE__*/_react.default.createElement("i", {
                            className: "fa fa-info-circle field-child-tooltip",
                            title: o.tooltipTitle
                        }) : "", /*#__PURE__*/_react.default.createElement("input", _extends({}, props, {
                            className: classNameCheckbox,
                            type: type,
                            key: o.key,
                            id: o.key,
                            name: o.name,
                            checked: checked,
                            value: o.value,
                            onChange: function onChange(e) {
                                _this.onChange(e, m.key, "multiple", m);
                            },
                            disabled: o.disabled
                        })), /*#__PURE__*/_react.default.createElement("label", {
                            htmlFor: o.key,
                            className: "custom-control-label grey-text",
                            key: "ll" + o.key
                        }, _t24(o.label))));
                    });
                    input = /*#__PURE__*/_react.default.createElement("div", {
                        className: ""
                    }, /*#__PURE__*/_react.default.createElement("label", {
                        className: "grey-text",
                        htmlFor: key
                    }, _t24(label)), input);
                }
                if (type == "icon" && (m.hide ? false : true)) {
                    input = /*#__PURE__*/_react.default.createElement("span", {
                        key: key,
                        id: m.key
                    }, /*#__PURE__*/_react.default.createElement("img", {
                        src: m.path,
                        name: m.name,
                        className: "imgIcon"
                    }));
                }
                return /*#__PURE__*/_react.default.createElement("div", {
                    key: "g" + key,
                    className: "form-group control" + index + " " + requiredFieldClass
                }, input, (m.hide ? false : true) ? validationMessage ? /*#__PURE__*/_react.default.createElement("span", {
                    className: "text-danger"
                }, " ", t(validationMessage)) : "" : "");
            });
            return formUI;
        });
        _this.fileRefs = [];
        for (var ind = 0; ind < _this.props.fileUploaderFields && _this.props.fileUploaderFields.length; ind++) {
            _this["fileRef" + _this.props.fileUploaderFields[ind]] = /*#__PURE__*/_react.default.createRef();
        }
        return _this;
    }
    _createClass(DynamicForm, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.props.onRef) {
                this.props.onRef(this);
            }
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            this.setState(_objectSpread({
                advanceLayoutFields: [],
                errors: {}
            }, nextProps.defaultValues));
            var errors = this.state.errors;
            Object.assign(errors, nextProps.extErrors);
            this.setState({
                errors: errors
            });
            var advanceLayoutFields = [];
            if (this.props.design === "advanceMaterial" || this.props.design === "advanceBootstrap") {
                // iterate fieldsets
                for (var i = 0; i < this.props.model.length; i++) {
                    // iterate columns
                    var columns = this.props.model[i]["columns"];
                    for (var j = 0; j < columns.length; j++) {
                        // if there is subfieldset then iterate through subfieldset and then rows
                        if (columns[j].hasOwnProperty("childType") && columns[j]["childType"] === "fieldset") {
                            // get child fieldsets
                            var childFieldsets = columns[j]["fieldsets"];
                            for (var l = 0; l < childFieldsets.length; l++) {
                                //iterate through rows for child field set
                                var rows = childFieldsets[l]["rows"];
                                // iterate rows
                                for (var m = 0; m < rows.length; m++) {
                                    advanceLayoutFields = advanceLayoutFields.concat(rows[m]);
                                }
                            }
                        } else {
                            var _rows = columns[j]["rows"];
                            // iterate rows
                            for (var k = 0; k < _rows.length; k++) {
                                advanceLayoutFields = advanceLayoutFields.concat(_rows[k]);
                            }
                        }
                    }
                }
                this.setState({
                    advanceLayoutFields: advanceLayoutFields
                });
            }

            // set editor state
            if (nextProps.editorFields) {
                for (var _j = 0; _j < nextProps.editorFields.length; _j++) {
                    if (nextProps.defaultValues && nextProps.defaultValues.hasOwnProperty(nextProps.editorFields[_j])) {
                        var content = this.getEditorContent("html", nextProps.defaultValues[nextProps.editorFields[_j]]);
                        this.setState(_defineProperty({}, "editorState" + nextProps.editorFields[_j], content));
                    } else {
                        this.setState(_defineProperty({}, "editorState" + nextProps.editorFields[_j], _draftJs.EditorState.createEmpty()));
                    }
                }
            }
            if (nextProps.defaultValues && Object.keys(nextProps.defaultValues).length > 0 && nextProps.preValidateForm) {
                this.validateForm();
            }

            // load default accordina states
            if (nextProps.defaultAccordianOpenStates) {
                this.setState({
                    collapseStates: _objectSpread(_objectSpread({}, this.state.collapseStates), nextProps.defaultAccordianOpenStates)
                });
            }
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            this.setState(_objectSpread({
                advanceLayoutFields: [],
                errors: {}
            }, this.props.defaultValues));
            var errors = this.state.errors;
            Object.assign(errors, this.props.extErrors);
            this.setState({
                errors: errors
            });
            var advanceLayoutFields = [];
            if (this.props.design === "advanceMaterial" || this.props.design === "advanceBootstrap") {
                // iterate fieldsets
                for (var i = 0; i < this.props.model.length; i++) {
                    // iterate columns
                    var columns = this.props.model[i]["columns"];
                    for (var j = 0; j < columns && columns.length; j++) {
                        // if there is subfieldset then iterate through subfieldset and then rows
                        if (columns[j].hasOwnProperty("childType") && columns[j]["childType"] === "fieldset") {
                            // get child fieldsets
                            var childFieldsets = columns[j]["fieldsets"];
                            for (var l = 0; l < childFieldsets.length; l++) {
                                //iterate through rows for child field set
                                var rows = childFieldsets[l]["rows"];
                                // iterate rows
                                for (var m = 0; m < rows.length; m++) {
                                    advanceLayoutFields = advanceLayoutFields.concat(rows[m]);
                                }
                            }
                        } else {
                            var _rows2 = columns[j]["rows"];
                            // iterate rows
                            for (var k = 0; k < _rows2.length; k++) {
                                advanceLayoutFields = advanceLayoutFields.concat(_rows2[k]);
                            }
                        }
                    }
                }
                this.setState({
                    advanceLayoutFields: advanceLayoutFields
                });
            }

            // set editor state
            if (this.props.editorFields) {
                for (var _j2 = 0; _j2 < this.props.editorFields.length; _j2++) {
                    if (this.props.defaultValues && this.props.defaultValues.hasOwnProperty(this.props.editorFields[_j2])) {
                        var content = this.getEditorContent("html", this.props.defaultValues[this.props.editorFields[_j2]]);
                        this.setState(_defineProperty({}, "editorState" + this.props.editorFields[_j2], content));
                    } else {
                        this.setState(_defineProperty({}, "editorState" + this.props.editorFields[_j2], _draftJs.EditorState.createEmpty()));
                    }
                }
            }
            if (this.props.defaultValues && Object.keys(this.props.defaultValues).length > 0 && this.props.preValidateForm) {
                this.validateForm();
            }

            // load default accordina states
            if (this.props.defaultAccordianOpenStates) {
                this.setState({
                    collapseStates: _objectSpread(_objectSpread({}, this.state.collapseStates), this.props.defaultAccordianOpenStates)
                });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;
            var t = this.props.t;
            var title = this.props.title || "Dynamic Form";
            var disabled = false;
            if (this.props.disableSubmitOnInValid) {
                disabled = !this.state.isValidForm;
            }
            // var disabled = this.props.disableSubmitOnInValid ? true : false;
            if (this.props.design === "material") {
                return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBContainer, {
                    className: this.props.className
                }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
                    md: "12"
                }, this.props.onRenderTitle ? this.props.onRenderTitle() : /*#__PURE__*/_react.default.createElement("h3", {
                    className: "form-title"
                }, t(title)), this.props.displayInformation ? /*#__PURE__*/_react.default.createElement("div", {
                    className: "form-display-info"
                }, t(this.props.displaydetails)) : "", this.props.extErrors && this.props.extErrors.hasOwnProperty("general") ? /*#__PURE__*/_react.default.createElement("div", {
                    className: "general-error text-danger"
                }, t(this.props.extErrors["general"])) : "", /*#__PURE__*/_react.default.createElement("form", {
                    className: "dynamic-form",
                    onSubmit: function onSubmit(e) {
                        _this2.onSubmit(e);
                    }
                }, /*#__PURE__*/_react.default.createElement("div", {
                    className: "grey-text"
                }, this.renderMaterialForm()), /*#__PURE__*/_react.default.createElement("div", {
                    className: "form-actions"
                }, this.props.extaraActionFormButton ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.extaraActionFormButton) : '', /*#__PURE__*/_react.default.createElement(_mdbreact.MDBBtn, {
                    disabled: disabled,
                    className: "btn btn-primary",
                    type: "submit"
                }, t(this.props.buttonSubmit ? this.props.buttonSubmit : "Submit")))))));
            } else if (this.props.design === "advanceMaterial") {
                return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBContainer, {
                    className: this.props.className
                }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
                    md: "12"
                }, this.props.onRenderTitle ? this.props.onRenderTitle() : /*#__PURE__*/_react.default.createElement("h3", {
                    className: "form-title"
                }, t(title)), this.props.displayInformation ? /*#__PURE__*/_react.default.createElement("div", {
                    className: "form-display-info"
                }, t(this.props.displaydetails)) : "", this.props.extErrors && this.props.extErrors.hasOwnProperty("general") ? /*#__PURE__*/_react.default.createElement("div", {
                    className: "general-error text-danger"
                }, t(this.props.extErrors["general"])) : "", /*#__PURE__*/_react.default.createElement("form", {
                    className: "dynamic-form",
                    onSubmit: function onSubmit(e) {
                        _this2.onSubmit(e);
                    }
                }, (0, _advanceDesign.renderAdvanceMaterialForm)(this.props, this.state, this.onChange, t, this.handleAutocompleteSelect, this.onEditorStateChange, this.onFileRef, this.props.onFileRemove, this.props.renderUploadedFilesItem, this.toggleCollapse, this.props.renderFieldsetAccordianLabel), /*#__PURE__*/_react.default.createElement("div", {
                    className: "form-actions"
                }, this.props.extaraActionFormButton ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.extaraActionFormButton) : '', /*#__PURE__*/_react.default.createElement(_mdbreact.MDBBtn, {
                    disabled: disabled,
                    className: "btn btn-primary",
                    type: "submit"
                }, t(this.props.buttonSubmit ? this.props.buttonSubmit : "Submit")))))));
            } else if (this.props.design === "advanceBootstrap") {
                return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBContainer, {
                    className: this.props.className
                }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
                    md: "12"
                }, this.props.onRenderTitle ? this.props.onRenderTitle() : /*#__PURE__*/_react.default.createElement("h3", {
                    className: "form-title"
                }, t(title)), this.props.displayInformation ? /*#__PURE__*/_react.default.createElement("div", {
                    className: "form-display-info"
                }, t(this.props.displaydetails)) : "", this.props.extErrors && this.props.extErrors.hasOwnProperty("general") ? /*#__PURE__*/_react.default.createElement("div", {
                    className: "general-error text-danger"
                }, t(this.props.extErrors["general"])) : "", /*#__PURE__*/_react.default.createElement("form", {
                    className: "dynamic-form",
                    onSubmit: function onSubmit(e) {
                        _this2.onSubmit(e);
                    }
                }, (0, _advanceDesignBootstrap.renderAdvanceBootstrapForm)(this.props, this.state, this.onChange, t, this.handleAutocompleteSelect, this.onEditorStateChange, this.onFileRef, this.props.onFileRemove, this.props.renderUploadedFilesItem, this.toggleCollapse, this.props.renderFieldsetAccordianLabel, this.onTriggerCheckinMap, this.onCheckinHandler, this.onCloseCheckInHandler), /*#__PURE__*/_react.default.createElement("div", {
                    className: "form-actions"
                }, this.props.extaraActionFormButton ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.extaraActionFormButton) : '', /*#__PURE__*/_react.default.createElement(_mdbreact.MDBBtn, {
                    color: "indigo",
                    disabled: disabled,
                    className: "btn btn-primary",
                    type: "submit"
                }, t(this.props.buttonSubmit ? this.props.buttonSubmit : "Submit")))))));
            } else {
                return /*#__PURE__*/_react.default.createElement(_mdbreact.MDBContainer, {
                    className: this.props.className
                }, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBRow, null, /*#__PURE__*/_react.default.createElement(_mdbreact.MDBCol, {
                    md: "12"
                }, this.props.onRenderTitle ? this.props.onRenderTitle() : /*#__PURE__*/_react.default.createElement("h3", {
                    className: "form-title"
                }, t(title)), this.props.displayInformation ? /*#__PURE__*/_react.default.createElement("div", {
                    className: "form-display-info"
                }, t(this.props.displaydetails)) : "", this.props.extErrors && this.props.extErrors.hasOwnProperty("general") ? /*#__PURE__*/_react.default.createElement("div", {
                    className: "general-error text-danger"
                }, t(this.props.extErrors["general"])) : "", /*#__PURE__*/_react.default.createElement("form", {
                    className: "dynamic-form",
                    onSubmit: function onSubmit(e) {
                        _this2.onSubmit(e);
                    }
                }, this.renderForm(), /*#__PURE__*/_react.default.createElement("div", {
                    className: "form-actions"
                }, this.props.extaraActionFormButton ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.extaraActionFormButton) : '', /*#__PURE__*/_react.default.createElement(_mdbreact.MDBBtn, {
                    color: "indigo",
                    disabled: disabled,
                    className: "btn btn-primary",
                    id: "submitButton",
                    type: "submit"
                }, t(this.props.buttonSubmit ? this.props.buttonSubmit : "Submit")))))));
            }
        }
    }]);
    return DynamicForm;
}(_react.default.Component);
var _default = (0, _reactI18next.withTranslation)()(DynamicForm);
exports.default = _default;